import Song from "./Song";
const Dashboard = () =>{
    return (
        <>
        <Song />
        </>
    )
}
export default Dashboard;